import { defineNuxtRouteMiddleware } from '#app'
import { abortPendingNavigationRequests } from '~/shared/composables/useNavigationAbort'

export default defineNuxtRouteMiddleware(() => {
  abortPendingNavigationRequests()
})
